import React from 'react';
import { StepWizardChildProps } from 'react-step-wizard';

import { Group, GroupForInfo } from 'models/response';

import utils from 'utils';

import { StepContainer, StyledRowWrapper, Top, StyledLine, StyledText } from './styles';

import Header from 'components/Modal/Header';
import CommonButton from 'components/Buttons/CommonButton';
import Dropdown from 'components/Input/dropdown/Dropdown';
import TextInput from 'components/Input/TextInput';

import Hierarchy from 'components/Hierarchy';

export interface Props extends StepWizardChildProps {
  groupsForInfo: GroupForInfo[];
  dropOptOne: { value: string; label: string }[];
  selectedReason: { value: string; label: string };
  infoInput: string;
  definitions: GroupForInfo[] | null;
  setSelectedWFDefinition: (definition: GroupForInfo) => void;
  setSelectedGroups: (groups: Group[]) => void;
}

const InfoStep: React.FC<Partial<Props>> = (props) => {
  const { goToStep, dropOptOne, selectedReason, infoInput, definitions, setSelectedWFDefinition, setSelectedGroups } =
    props;
  const t = utils.intl.useTranslator();

  const columns = [
    { accessor: 'username', Header: 'User' },
    { accessor: 'name', Header: 'Name' },
  ];

  const searchTypeValues: { value: string; label: string; parent: 'one' | 'two' | 'three' | 'table' }[] = [
    { value: 'task', label: 'Task', parent: 'one' },
    { value: 'group', label: 'Group', parent: 'two' },
    { value: 'user', label: 'User', parent: 'table' },
  ];

  return (
    <StepContainer>
      <Header title={t('send-to-workflow')} />
      {dropOptOne ? (
        <Top>
          <CommonButton id="back-btn" value={t('back')} scope="tertiary" action={() => (goToStep ? goToStep(1) : {})} />
          <StyledRowWrapper>
            <Dropdown id="reason-dropdown" value={selectedReason} disabled options={dropOptOne} />
            <TextInput id="info-step-input" disabled value={infoInput} />
          </StyledRowWrapper>
        </Top>
      ) : null}
      <StyledLine />
      <StyledText>{t('info-selected')}</StyledText>
      {definitions && (
        <Hierarchy
          title="definition-wf-selected"
          hasSearch
          searchTypeValues={searchTypeValues}
          parentsOne={definitions}
          parentOneName="wfName"
          parentOneId="idWorkflowDefinition"
          parentOneSelection={(value: any) => {
            setSelectedWFDefinition && setSelectedWFDefinition(value);
            setSelectedGroups && setSelectedGroups([]);
          }}
          parentOneChild="groups"
          parentTwoName="groupName"
          parentTwoId="idGroup"
          parentTwoSelection={(isActive?: boolean, value?: any) => {
            setSelectedGroups && setSelectedGroups(value);
          }}
          parentTwoChild="users"
          parentTwoHasTable={true}
          idRowTable="idUser"
          columns={columns}
          tableValueName="username"
          tableValueNameTwo="name"
          toCleanSelections={selectedReason}
        />
      )}
    </StepContainer>
  );
};

export default InfoStep;
